/* ═══════════════════════════════════════════════════════════════
   SENDEGARO — Boost Commerce Filter Sort Order
   ═══════════════════════════════════════════════════════════════
   Purpose: Custom sort order for Boost Commerce filter values.

   Sort priority:
     1. Alpha/SML sizes first (XXS → XS → S → M → L → XL → XXL…)
     2. IT-prefixed sizes next (IT 36 → IT 38 → …)
     3. Plain numbers (27, 28, 29…)
     4. US shoe sizes (US 5 → US 6 → …)
     5. EU-prefixed sizes last (EU 35 → EU 36 → …)

   All size display/conversion is now handled server-side via
   metafields (custom.size_display, custom.size_standard) and
   Liquid theme snippets. This file ONLY handles sort order.
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Alpha/SML sort order ── */
  var alphaOrder = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', 'ONE SIZE'];
  var alphaAlias = {
    '3XS': 'XXXS', '4XS': 'XXXS', '5XS': 'XXXS',
    '2XL': 'XXL', '3XL': 'XXXL', '4XL': 'XXXXL',
    'OS': 'ONE SIZE', 'ONESIZE': 'ONE SIZE', 'UNI': 'ONE SIZE', 'O/S': 'ONE SIZE'
  };

  function tokenize(raw) {
    return (raw == null ? '' : raw)
      .toString().toUpperCase()
      .replace(/½/g, '.5')
      .replace(/[^A-Z0-9./]+/g, ' ')
      .trim().split(/\s+/).filter(Boolean);
  }

  function getAlphaIndex(tokens) {
    for (var i = 0; i < tokens.length; i++) {
      var tok = alphaAlias[tokens[i]] || tokens[i];
      if (tok === 'ONE SIZE') return 100; /* Always last among sizes, matches theme.js */
      var idx = alphaOrder.indexOf(tok);
      if (idx !== -1) return idx;
      var mXL = tok.match(/^(\d+)XL$/);
      if (mXL) {
        var nXL = parseInt(mXL[1], 10);
        if (nXL === 2) return alphaOrder.indexOf('XXL');
        if (nXL === 3) return alphaOrder.indexOf('XXXL');
        var baseXL = alphaOrder.indexOf('XXXL');
        return baseXL !== -1 ? baseXL + (nXL - 3) : 999;
      }
      var mXS = tok.match(/^(\d+)XS$/);
      if (mXS) {
        return 0; /* Before XXXS — any NXS is the smallest */
      }
    }
    return null;
  }

  function getWeight(val) {
    var raw = (val && val.key != null ? val.key : '').toString().trim();

    /* 1. Alpha/SML → sort FIRST (weight 0-20) */
    var tokens = tokenize(raw);
    var alphaIdx = getAlphaIndex(tokens);
    if (alphaIdx !== null) return alphaIdx;

    /* 2. IT-prefixed → sort after alpha (weight 50+) */
    var itMatch = raw.match(/^IT\s*(\d+(?:\.\d+)?)/i);
    if (itMatch) return 50 + parseFloat(itMatch[1]);

    /* 3. Plain numbers → sort MIDDLE (weight 100+) */
    for (var i = 0; i < tokens.length; i++) {
      if (/^\d+(\.\d+)?$/.test(tokens[i])) {
        return 100 + parseFloat(tokens[i]);
      }
    }

    /* 4. US-prefixed shoe sizes → sort after plain numbers (weight 500+) */
    var usMatch = raw.match(/^US\s*(\d+(?:\.\d+)?)/i);
    if (usMatch) return 500 + parseFloat(usMatch[1]);

    /* 5. EU-prefixed → sort LAST (weight 1000+) */
    var euMatch = raw.match(/^EU\s*(\d+(?:\.\d+)?)/i);
    if (euMatch) return 1000 + parseFloat(euMatch[1]);

    /* 6. UK-prefixed → sort after US (weight 700+) */
    var ukMatch = raw.match(/^UK\s*(\d+(?:\.\d+)?)/i);
    if (ukMatch) return 700 + parseFloat(ukMatch[1]);

    /* Fallback: try to extract any number */
    var m = raw.replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    if (m) return 100 + parseFloat(m[1]);

    return 9999;
  }

  /* ── Boost Commerce sort callback ── */
  window.boostCustomSortOptionValues = function (values, option) {
    /* Size filter — sort by weight (SML first, then numeric) */
    if (option.filterOptionId === 'pf_opt_size' ||
        option.filterOptionId.indexOf('size') !== -1) {
      return option.values.sort(function (a, b) {
        var wa = getWeight(a), wb = getWeight(b);
        if (wa !== wb) return wa - wb;
        var ka = (a.key == null ? '' : a.key).toString();
        var kb = (b.key == null ? '' : b.key).toString();
        return ka.localeCompare(kb, undefined, { numeric: true, sensitivity: 'base' });
      });
    }

    /* Color filter — alphabetical */
    if (option.filterOptionId === 'pf_t_color' ||
        option.filterOptionId.indexOf('color') !== -1) {
      return option.values.sort(function (a, b) {
        return (a.key || '').toLowerCase().localeCompare((b.key || '').toLowerCase());
      });
    }

    return option.values;
  };

})();
